export function hashStr(str, seed = 0) {
  if (!str) return str;
  let h1 = 0xdeadbeef ^ seed; let
    h2 = 0x41c6ce57 ^ seed;
  for (let i = 0, ch; i < str.length; i++) {
    ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
  h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
  h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);

  return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}
export function capitalize(str) {
  return `${str[0].toUpperCase()}${str.substring(1)}`;
}

export const pluralize = (word, qty) => {
  if (qty < 2) return word;
  if (word.toLowerCase() === 'person') return 'people';

  const esEndings = ['s', 'ss', 'sh', 'ch', 'x', 'z'];
  const needES = esEndings.some((ending) => word.endsWith(ending));

  return `${word}${needES ? 'es' : 's'}`;
};

export function getServingSizeLabel(servingSize) {
  if (!servingSize) {
    return '';
  }
  return `Serves ${servingSize} ${servingSize > 1 ? 'people' : 'person'}`;
}

export const validateEmail = (emailText) => {
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  if (!emailRegex.test(emailText)) {
    return false;
  }
  return true;
};
